class ProgressoCadastroContratoModal {
    constructor(gql, $scope) {
        this.gql = gql
        this.apply = fun => $scope.$applyAsync(fun)

        this.steps = {}
    }

    async $onInit() {
        try {
            const { certificado, empresa, filiais } = this.resolve

            this.contrato = await this.createContrato(empresa)

            await this.createCertificado(this.contrato, certificado)

            await this.createFiliais(this.contrato, filiais)

            this.ended = true

            this.apply()
        } catch (err) {
            this.error = true
            this.apply()
        }
    }

    createContrato(contrato) {
        const mutation = gql`
            mutation CreateEmpresa($params: EmpresaParams!) {
                contrato: createEmpresa(params: $params) {
                    id
                }
            }
        `

        const variables = {
            params: {
                razaoSocial: contrato.razaoSocial,
                raizCnpj: contrato.raizCnpj
            }
        }

        this.steps.contrato = {
            mensagem: 'Cadastrando uma nova empresa...',
            status: 'processando'
        }

        return this.gql.mutate(mutation, variables)
            .then(({ contrato: { id } }) => {
                this.steps.contrato = {
                    mensagem: 'A empresa foi cadastrada com sucesso!',
                    status: 'sucesso'
                }

                return { ...contrato, id }
            })
            .catch(err => {
                this.steps.contrato = {
                    mensagem: 'Não foi possível cadastrar a empresa.',
                    status: 'falha'
                }

                throw err
            })
    }

    createCertificado(contrato, certificado) {
        const mutation = gql`
            mutation UpdateCertificado($contratoId: Int!, $arquivo: Upload!, $senha: String!) {
                certificado: updateCertificado(empresaId: $contratoId, arquivo: $arquivo, senha: $senha) {
                    id
                }
            }
        `

        const variables = {
            contratoId: parseInt(contrato.id),
            arquivo: certificado.arquivo,
            senha: certificado.senha
        }

        this.steps.certificado = {
            mensagem: 'Adicionando o certificado da empresa...',
            status: 'processando'
        }

        this.apply()

        return this.gql.mutate(mutation, variables)
            .then(() => {
                this.steps.certificado = {
                    mensagem: 'O certificado foi adicionado com sucesso!',
                    status: 'sucesso'
                }
            })
            .catch(() => {
                this.steps.certificado = {
                    mensagem: 'Não foi possível adicionar o certificado da empresa.',
                    status: 'falha',
                    retry: () => this.createCertificado(contrato, certificado)
                }
            })
            .then(() => this.apply())
    }

    createFiliais(contrato, [filial, ...filiais]) {
        if (!filial) return this.apply()

        const mutation = gql`
            mutation CreateFilial($empresaId: String!, $params: FilialParams!) {
                empresa(id: $empresaId) {
                    empresa: createFilial(params: $params) {
                        id
                        status: ativa
                    }
                }
            }
        `
        
        const variables = {
            empresaId: contrato.id,
            params: {
                razaoSocial: filial.razaoSocial,
                cnpj: filial.cnpj,
                cidadeId: filial.cidade.id
            }
        }

        const finalCnpj = `${filial.cnpj.slice(8, 12)}-${filial.cnpj.slice(12)}`

        this.steps[filial.cnpj] = {
            mensagem: `Adicionando a filial ${finalCnpj}`,
            status: 'processando'
        }

        this.apply()

        return this.gql.mutate(mutation, variables)
            .then(() => {
                this.steps[filial.cnpj] = {
                    mensagem: `A filial ${finalCnpj} foi adicionada com sucesso!`,
                    status: 'sucesso'
                }
            })
            .catch(() => {
                this.steps[filial.cnpj] = {
                    mensagem: `Não foi possível adicionar a filial ${finalCnpj}.`,
                    status: 'falha',
                    retry: () => this.createFiliais(contrato, [filial])
                }
            })
            .then(() => this.createFiliais(contrato, filiais))
    }

    get hasErrors() {
        return Object
            .values(this.steps)
            .some(s => s.status !== 'sucesso')
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('progressoCadastroContratoModal', {
        controller: ['gql', '$scope', ProgressoCadastroContratoModal],
        bindings: {
            close: '&',
            resolve: '<',
            dismiss: '&'
        },
        template: `
            <modal>
                <modal-body>
                    <div class="clearfix">
                        <div class="slide-animation" ng-hide="$ctrl.ended || $ctrl.error">
                            <highlighted>
                                <main>Aguarde<span>.</span><span>.</span><span>.</span></main>
                                <secondary>Estamos preparando tudo para você.</secondary>
                            </highlighted>
                        </div>

                        <div class="progresso slide-animation" ng-hide="$ctrl.error">
                            <div class="line">
                            </div>
                            <div ng-repeat="(key, step) in $ctrl.steps" class="progresso-item repeat-animation" ng-class="{'active': step.status === 'processando'}">
                                <div class="bullet">
                                    <span ng-switch="step.status">
                                        <span ng-switch-when="processando">
                                            <i class="fa fa-spinner fa-spin text-muted"></i>
                                        </span>
                                        <span ng-switch-when="sucesso">
                                            <i class="fa fa-check text-success"></i>
                                        </span>
                                        <span ng-switch-when="falha">
                                            <i class="fa fa-close text-danger"></i>
                                        </span>
                                    </span>
                                </div>
                                <div class="content">
                                    <span>{{step.mensagem}}</span>
                                    <div ng-if="step.retry">
                                        <small>
                                            <a href="" ng-click="step.retry()">Tentar novamente</a>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="slide-animation" ng-show="$ctrl.ended && !$ctrl.hasErrors">
                            <highlighted>
                                <main>Tudo pronto!</main>
                                <secondary>O Eficiência Fiscal já esta funcionando para a sua empresa.</secondary>
                            </highlighted>
                        </div>

                        <div class="slide-animation" ng-show="$ctrl.ended && $ctrl.hasErrors">
                            <highlighted>
                                <main>Algumas coisas não saíram como o planejado...</main>
                                <secondary>
                                    Você pode clicar em "Tentar novamente" ou acessar as configurações da empresa mais tarde.
                                    <br/>
                                    Qualquer dúvida, entre em contato com o nosso suporte.
                                </secondary>
                            </highlighted>
                        </div>

                        <div class="slide-animation" ng-show="$ctrl.error">
                            <highlighted>
                                <main>Ocorreu um erro ao cadastrar a empresa.</main>
                                <secondary>Entre em contato com nosso suporte ou tente novamente mais tarde.</secondary>
                            </highlighted>
                        </div>

                        <div class="final-button fade-animation" ng-show="$ctrl.error">
                            <button class="btn btn-primary" ng-click="$ctrl.dismiss()">Voltar ao cadastro</button>
                        </div>

                        <div class="final-button fade-animation" ng-show="$ctrl.ended">
                            <button class="btn btn-primary" ng-click="$ctrl.close({$value: $ctrl.contrato})">Ok, finalizar!</button>
                        </div>
                    </div>
                </modal-body>
            </modal>
        `
    })
